<template>
  <PageTemplate
    :datas="datas"
    :nv-items="nvItems"
    :lang="lang"
    page-name="contact"
    @homeClick="homeClick"
  />
</template>

<script>
import PageTemplate from "@/components/PageTemplate.vue";
import { getContact } from "@/api/data.js";
export default {
  components: {
    PageTemplate,
  },
  props: ["lang"],
  data() {
    return {
      datas: [],
      activeItem: 0,
      nvItems: [
        {
          name: "首页",
          path: "/",
          enName: "Home",
        },
        {
          name: "联系",
          path: "",
          enName: "Contact",
        },
      ],
    };
  },
  mounted() {
    console.log("---------------");
    this.getData();
  },
  methods: {
    menuItemClick(e) {
      this.activeItem = parseInt(e);
    },
    homeClick() {
      this.$emit("toHome");
    },
    getData() {
      let that = this;
      getContact()
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            let data = response.data.data;
            that.datas = data;
          } else {
            that.datas = [];
          }
        })
        .catch((error) => {
          console.log(error);
          that.datas = [];
        });
    },
  },
};
</script>

<style scoped></style>
